var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoveNewImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2239_6)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M2.23125 13.0813L10.7016 20.9891C11.0531 21.3172 11.5172 21.5 12 21.5C12.4828 21.5 12.9469 21.3172 13.2984 20.9891L21.7687 13.0813C23.1938 11.7547 24 9.89376 24 7.94844V7.67657C24 4.40001 21.6328 1.60626 18.4031 1.06719C16.2656 0.710947 14.0906 1.40938 12.5625 2.93751L12 3.50001L11.4375 2.93751C9.90938 1.40938 7.73438 0.710947 5.59688 1.06719C2.36719 1.60626 0 4.40001 0 7.67657V7.94844C0 9.89376 0.80625 11.7547 2.23125 13.0813Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2239_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveNewImage);
export default __webpack_public_path__ + "static/media/love-new-image.c39381241251586a42f30996dc36321f.svg";
export { ForwardRef as ReactComponent };